import { auth } from '../libs/Firebase'
import { FirebaseUser } from '../ygdrasil/types/types'

export default function useFirebaseUser(): FirebaseUser | null {
  const { currentUser } = auth
  return currentUser
}
